import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { ApiService, getResponse, updateResponse } from '../api.service';
import { ProductStock } from '@models';

@Injectable()
export class StockService extends ApiService<ProductStock> {

    protected apiGroup: string = 'shop';
	protected apiName: string = 'stock';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
    }
    
	/**
	 * getProductStock(parameters)
	 * Retrieve all stock of product
     * 
     * @param productId
	 */
	getProductStock(productId: number): Observable<getResponse<ProductStock>> {
        return this.http.get<getResponse<ProductStock>>(
            this.getBaseUrl('get_product_stock', productId.toString())
        ).retry(this.retries);
    }

    updateProductStock(productId: number, amount: number): Observable<updateResponse<ProductStock>> {
        return this.http.post<updateResponse<ProductStock>>(
			this.getBaseUrl('update_product_stock', productId.toString()),
			{
                'amount': amount
            }
		);
    }

    /* updateProductBackorder(stockItemId: number, productId: number, backorder: boolean): Observable<updateResponse<ProductStock>> {
        return this.http.post<updateResponse<ProductStock>>(
			this.getBaseUrl('update_product_backorder', productId.toString()),
			{
                'product_stock_item_id': stockItemId,
                'backorder': backorder
            }
		);
    } */
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/services/shop/stock.service.ts